import { Component } from '@angular/core';
import { dataClients } from '@modules/home/home-data';
import { ClientHome } from '@shared/data-structure/interfaces';

@Component({
  selector: 'astrea-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent {

  public clients: ClientHome[] = [];

  constructor () {
    this.clients = this.sortRandom();
  }

  sortRandom() {
    return dataClients.sort(() => Math.random() - 0.5);
  }

}
